import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import type { IRootDispatch } from '../../../../../store/models';

import { ProviderRecommendationData } from '../../../../../store/Recommendations.model';

import { useAsyncEffect, useResponsiveEffect } from '../../../../../hooks';

export type UseMarketPlaceProfileHookProps = {
  providerId: number;
};

export type UserMarketplaceProfileHookData = {
  providerRecommendation: ProviderRecommendationData;
};

export const useMarketplaceProfile = ({
  providerId,
}: UseMarketPlaceProfileHookProps): void => {
  const dispatch = useDispatch() as IRootDispatch;

  // Use ref to allow for a single time use of `useAsyncEffect`
  const assignmentCalledRef = useRef<boolean>(false);

  const runMarketplaceProfileUpdates = useCallback(async () => {
    if (assignmentCalledRef.current) {
      await dispatch.marketplaceProfile.resetUI();
      await dispatch.marketplaceProfile.assignUI({ providerId });
    }
  }, [
    dispatch.marketplaceProfile,
    providerId,
  ]);

  useAsyncEffect(async () => {
    if (!assignmentCalledRef.current && providerId) {
      await dispatch.marketplaceProfile.resetUI();
      await dispatch.recommendations.loadProviderRecommendations({ providerId });
      assignmentCalledRef.current = true;
      await dispatch.marketplaceProfile.assignUI({ providerId });
    }
  }, [providerId]);

  // when use change the layout the assign UI will change;
  useResponsiveEffect(runMarketplaceProfileUpdates);
};
